import { GetUserResponseDto } from '@modusign/openapi-client-user/generated/model';
import { AxiosError } from 'axios';

import { ThirdPartyIdProvider } from '@app/constants/IdProvider';
import { AccountLocalAction } from '@app/store/account/local/actions';
import { AccountPasswordAction } from '@app/store/account/password/actions';
import { AccountSignOutAction } from '@app/store/account/sign-out/actions';
import { AccountSignUpAction } from '@app/store/account/sign-up/actions';
import { AccountSurveyAction } from '@app/store/account/survey/actions';
import { AccountThirdPartyAction } from '@app/store/account/third-party/actions';
import {
  ACCOUNT_AUTHENTICATION_RESET,
  ACCOUNT_AUTHENTICATION_SET,
  ACCOUNT_INACTIVE_ACTIVATE_FAILURE,
  ACCOUNT_INACTIVE_ACTIVATE_REQUEST,
  ACCOUNT_INACTIVE_ACTIVATE_SUCCESS,
  ACCOUNT_LOAD_FAILURE,
  ACCOUNT_LOAD_REQUEST,
  ACCOUNT_LOAD_SUCCESS,
  ACCOUNT_SECESSION_FAILURE,
  ACCOUNT_SECESSION_REQUEST,
  ACCOUNT_SECESSION_SUCCESS,
  ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_FAILURE,
  ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_REQUEST,
  ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_SUCCESS,
} from '@app/store/actionTypes';

export function resetAuthentication() {
  return {
    type: ACCOUNT_AUTHENTICATION_RESET,
  };
}

export function setAuthentication(payload: boolean) {
  return {
    type: ACCOUNT_AUTHENTICATION_SET,
    payload,
  };
}

export function leaveAccount(password: string, reason: string) {
  return {
    type: ACCOUNT_SECESSION_REQUEST,
    payload: { password, reason },
  };
}

export function leaveAccountSuccess() {
  return {
    type: ACCOUNT_SECESSION_SUCCESS,
  };
}

export function leaveAccountFailure(error: AxiosError) {
  return {
    type: ACCOUNT_SECESSION_FAILURE,
    payload: error,
    error: true,
  };
}

export function loadAccount() {
  return {
    type: ACCOUNT_LOAD_REQUEST,
  };
}

export function loadAccountSuccess(payload: GetUserResponseDto) {
  return {
    type: ACCOUNT_LOAD_SUCCESS,
    payload,
  };
}

export function loadAccountFailure(error: AxiosError) {
  return {
    type: ACCOUNT_LOAD_FAILURE,
    payload: error,
    error: true,
  };
}

/** @deprecated */
export function activateInactiveAccount(payload: { email: string; password: string }) {
  return {
    type: ACCOUNT_INACTIVE_ACTIVATE_REQUEST,
    payload,
  };
}

/** @deprecated */
export function activateInactiveAccountSuccess(payload: { email: string; password: string }) {
  return {
    type: ACCOUNT_INACTIVE_ACTIVATE_SUCCESS,
    payload,
  };
}

/** @deprecated */
export function activateInactiveAccountFailure(error: AxiosError) {
  return {
    type: ACCOUNT_INACTIVE_ACTIVATE_FAILURE,
    payload: error,
    error: true,
  };
}

/** @deprecated */
export function activateThirdPartyInactiveAccount(payload: {
  code: string;
  provider: ThirdPartyIdProvider;
}) {
  return {
    type: ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_REQUEST,
    payload,
  };
}

/** @deprecated */
export function activateThirdPartyInactiveAccountSuccess(payload: {
  code: string;
  provider: ThirdPartyIdProvider;
}) {
  return {
    type: ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_SUCCESS,
    payload,
  };
}

/** @deprecated */
export function activateThirdPartyInactiveAccountFailure(error: AxiosError) {
  return {
    type: ACCOUNT_THIRD_PARTY_INACTIVE_ACTIVATE_FAILURE,
    payload: error,
    error: true,
  };
}

export type AccountAction =
  | AccountLocalAction
  | AccountPasswordAction
  | AccountSignOutAction
  | AccountSignUpAction
  | AccountSurveyAction
  | AccountThirdPartyAction
  | ReturnType<typeof resetAuthentication>
  | ReturnType<typeof setAuthentication>
  | ReturnType<typeof leaveAccount>
  | ReturnType<typeof leaveAccountSuccess>
  | ReturnType<typeof leaveAccountFailure>
  | ReturnType<typeof loadAccount>
  | ReturnType<typeof loadAccountSuccess>
  | ReturnType<typeof loadAccountFailure>
  | ReturnType<typeof loadAccount>
  | ReturnType<typeof activateInactiveAccount>
  | ReturnType<typeof activateInactiveAccountSuccess>
  | ReturnType<typeof activateInactiveAccountFailure>
  | ReturnType<typeof activateThirdPartyInactiveAccount>
  | ReturnType<typeof activateThirdPartyInactiveAccountSuccess>
  | ReturnType<typeof activateThirdPartyInactiveAccountFailure>;
